'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.postApplication = exports.jobById = exports.jobs = undefined;

var _keys = require('babel-runtime/core-js/object/keys');

var _keys2 = _interopRequireDefault(_keys);

var _sagaTools = require('@classpass/saga-tools');

var _universalFetch = require('../../../universal-fetch');

var _universalFetch2 = _interopRequireDefault(_universalFetch);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var jobs = exports.jobs = (0, _sagaTools.makeEntityScaffold)('SAGA.FETCH_JOBS', function () {
  if (__SERVER__) {
    var getJobs = require('../../../../server/handlers/job-posts').getJobs;
    return getJobs();
  }

  return (0, _universalFetch2.default)('/_jobs').then(function (res) {
    return res.json();
  });
});

var jobById = exports.jobById = (0, _sagaTools.makeEntityScaffold)('SAGA.FETCH_JOB_BY_ID', function (client, id) {
  if (__SERVER__) {
    var getJob = require('../../../../server/handlers/job-posts').getJob;
    return getJob(id);
  }

  return (0, _universalFetch2.default)('/_jobs/' + id).then(function (res) {
    return res.json();
  });
}, { defaultKey: 1 });

var postApplication = exports.postApplication = (0, _sagaTools.makeEntityScaffold)('SAGA.CREATE_APPLICATION', function (client, payload) {
  var body = new FormData();

  (0, _keys2.default)(payload).forEach(function (key) {
    if (payload[key]) {
      body.append(key, payload[key]);
    }
  });

  return (0, _universalFetch2.default)('/_jobs', {
    method: 'POST',
    body: body
  }).then(function (res) {
    return res.json();
  });
});